<template>
    <rkm-modal
        v-if="!!model"
        large
        ref="RkmModal"
        title="Perfil epidemiológico"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        inline
                        text-field="descricao"
                        v-model="model.perfisEpidemiologicos"
                        value-field="id"
                    >
                        <rkm-form-checkbox
                            v-for="perfilEpidemiologico in data.form.perfisEpidemiologicos"
                            :key="perfilEpidemiologico.id"
                            :value="perfilEpidemiologico.id"
                            class="w-50 m-0"
                        >
                            {{ perfilEpidemiologico.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :maxlength="validations.observacaoPerfilEpidemiologico.max"
                        :validations="validations.observacaoPerfilEpidemiologico"
                        label="Observações"
                        rows="6"
                        v-model="model.observacaoPerfilEpidemiologico"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="store"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                observacaoPerfilEpidemiologico: {
                    max: 500
                }
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            perfisEpidemiologicos: [],
            observacaoPerfilEpidemiologico: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item
            this.model = this.clone(this.item)
            this.$refs.RkmModal.show()
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    Object.assign(this.item, this.model)
                    this.$refs.RkmModal.hide()
                })
        },
    },
    mixins: [error, object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>